export const EventDateFormat = 'dddd DD MMM yyyy';
export const ORGANIZATION_EVENT_DRAWER_HELPER =
  'All Organization Events are posted on the home feed';
